import React from 'react'
import { Link } from 'react-router-dom'
import { Badge, ListGroup, ListGroupItem } from 'reactstrap'
import { useLookupConfigs } from 'src/queries'

const Body: React.FC = (props) => {
  const lookups = useLookupConfigs()
  return (
    <ListGroup flush className='border-top-0'>
      {lookups?.map((lookup) => (
        <ListGroupItem
          action
          key={lookup._id}
          to={lookup._id}
          tag={Link}
          className='d-flex justify-content-between align-items-center'
        >
          {lookup.name}
          <Badge pill>
            {lookup.optionsCount} Options
          </Badge>
        </ListGroupItem>
      ))}
    </ListGroup>
  )
}

export default Body
